import { lazy } from 'react';

const PublicUnsubscribePage = lazy(() => import('src/pages/public/unsubscribe'));

// Opened from the unsubscribe link in a quick-message email. No AuthGuard or GuestGuard, like
// the join and survey routes.
export const publicUnsubscribeRoutes = [
  {
    path: 'unsubscribe',
    element: <PublicUnsubscribePage />,
  },
];
